module.exports = {
  "createContextualTemplate": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "templateId": "number",
      "type": "string",
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "createContextualWorkflow": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "imageId": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "deleteContextualWorkflow": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "isRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "externalNavigation": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "component": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "relatedWorkflowsTableInteraction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "type": "string",
      "name": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "updateContextualWorkflow": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "isRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "viewKnowledgeBaseArticle": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "document": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  },
  "viewedComponent": {
    "name": "usage",
    "class": "usage",
    "properties": {
      "component": "string",
      "action": "string",
      "sourceApp": "string"
    },
    "namespace": "contextual-automation"
  }
};